
import FF_Module from './FF_Module'; // eslint-disable-line no-autofix/snakecasejs/snakecasejs

/**
 * Module qui gère l'alternance gauche/droite des éléments textuels des blocs modulaire ".text-mb".
 */
export default class FF_Text_MB extends FF_Module {
  init() {

    // Bail si le bloc n'a pas la classe ".text-mb--alternating-paragraphs"
    if (!$(this.elements.container).hasClass('text-mb--alternating-paragraphs')) {
      return;
    }

    // Éléments
    this.elements = {
      ...this.elements,
      text         : $(this.elements.container).find('.text-mb__text').get(0),
      text_elements: $(this.elements.container).find('.text-mb__text > *').toArray()
    };
    $(this.elements.text_elements).addClass('text-mb__text-element');

    // Ajoute les classes d'alternance aux éléments
    this.elements.text_elements.reduce((align_element_to_right, element) => {

      if (align_element_to_right) {
        $(element).addClass('text-mb__text-element--right');
      }

      // Détermine l'alignement du prochain élément
      let align_next_element_to_right = !align_element_to_right;
      if (!$(element).is('p') && !$(element).is('ul')) {
        align_next_element_to_right = !align_next_element_to_right;
      }
      return align_next_element_to_right;

    }, false);

  }
}
